<template>
  <div>
    <TableFilters
      :filters="['customer', 'customerType', 'dateRange']"
      :columns="columns"
      v-model="filter"
      @updateColumnsTable="updateColumnsTable"
      :export="[`productexport`]"
    ></TableFilters>
    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn @click="viewpdfFile()"> View Report </v-btn>
          <v-btn @click="exportPDF()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-card class="mt-2" v-show="false">
      <v-container fluid>
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :fixed-header="true"
              :headers="headers"
              :items="customersales"
              item-key="id"
              class="row-pointer product-list"
              id="indextable13"
            >
              <template v-slot:item.date="{ item }">
                <div>
                  {{ item.date | formatDate }}
                </div>
              </template>
              <template v-slot:item.biller="{ item }">
                <div>
                  {{ item.biller.first_name }}
                </div>
              </template>

              <template v-slot:item.shop="{ item }">
                <div>
                  {{ item.shop.name }}
                </div>
              </template>
              <template
                slot="body.append"
                v-if="customersales && customersales.length > 0"
              >
                <tr class="black--text">
                  <th class="title"></th>
                  <th class="title"></th>
                  <th>
                    <h3 class="justify-content-end pl-2">
                      {{ total | formatCurrency }}
                    </h3>
                  </th>
                  <th>
                    <h3 class="justify-content-end pl-2">
                      {{ discount | formatCurrency }}
                    </h3>
                  </th>

                  <th>
                    <h3 class="justify-content-end">
                      {{ paid | formatCurrency }}
                    </h3>
                  </th>
                  <th class="title"></th>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
// Components
import PageTitle from '@/components/shared/PageTitle';
import ProductListPdf from './PDF/ProductsList.vue';
import TableFilters from '@/components/base/TableFilters';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import _ from 'lodash';
import axios from '@/plugins/axios';
import { mapState } from 'vuex';

export default {
  data: () => ({
    columns: [
      {
        text: 'Date',
        value: 'date',
        show: true,
        disabled: false,
        render: (item) => moment(item.date).format('YYYY-MM-DD'),
      },
      {
        text: 'Shop',
        value: 'shop',
        show: true,
        disabled: false,
        render: (item) => item?.shop.name,
      },
      {
        text: 'Total ',
        value: 'grand_total',
        show: true,
        align: 'left',
        disabled: false,
        render: (item) => item?.grand_total,
      },

      {
        text: 'Discount ',
        value: 'discount_amount',
        align: 'center',
        show: true,
        disabled: false,
        render: (item) => item?.discount_amount,
      },
      {
        text: 'Paid',
        value: 'paid_amount',
        align: 'center',
        show: true,
        disabled: false,
        render: (item) => item?.paid_amount,
      },
      {
        text: ' Type',
        value: 'sale_type',
        align: 'center',
        show: true,
        disabled: false,
        render: (item) => item?.sale_type,
      },
      {
        text: 'Biller',
        value: 'biller',
        align: 'center',
        show: true,
        disabled: false,
        render: (item) => item?.biller.first_name,
      },

      {
        text: 'Status',
        value: 'status',
        show: true,
        disabled: false,
        render: (item) => item?.status,
      },
    ],

    customersales: [],
    hide: '',
    // Filters
    filter: {
      customer: '',
      search: '',
      status: '',
      total: 0,
      paid: 0,
      discount: 0,
    },
  }),
  components: {
    PageTitle,
    TableFilters,
    ProductListPdf,
  },

  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    generateReport(callBack = () => {}) {
      if (this.filter.customer) {
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);

        var filter = this.filter;
        axios
          .get(
            `reports/customers/${filter.customer}/sales?customerType=${
              filter.customerType ? filter.customerType : ''
            }`,
          )

          .then((res) => {
            this.customersales = res.data;
            this.total = this.sumField(this.customersales, 'grand_total');
            this.discount = this.sumField(
              this.customersales,
              'discount_amount',
            );
            this.paid = this.sumField(this.customersales, 'paid_amount');
            let i = 1;
            this.customersales.map((p) => {
              p.no = i;
              i++;
            });
            var purchaseAmount = {
              total: this.total,
              discount: this.discount,
              paid: this.paid,
            };
            setTimeout(() => {
              callBack();
              // Update Pdf To List

              this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
              // Update Pdf To List Datas
              this.$store.commit('UPDATE_PDF_DATAS', this.customersales);
              // Update Pdf To List_Title
              this.$store.commit('UPDATE_PDF_TITLE', 'Customer Sales');
              this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
              this.$store.commit('UPDATE_PURCHASE_TOTAL', purchaseAmount);
            }, 100);
          })
          .catch((err) => {
            this.isLoading = false;
            this.$store.commit('UPDATE_PDF_VISIBLE', false);
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);

            this.messages = err.data.title;
          });
      } else {
        this.$confirm('Please Select the Customer then Try?');
      }
    },
    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        if (this.customersales.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 400);
    },

    sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += parseInt(element[filed]);
      });
      return value;
    },

    exportPDF() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.customersales);
        for (let x = 0; x < Data.length; x++) {
          Data[x].date = moment(Data[x].date, 'YYYY-MM-DD').format(
            'DD/MM/YYYY',
          );
          Data[x].biller = Data[x].biller.first_name;
          Data[x].shop = Data[x].shop.name;
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica');
        doc.text('Customer Sales', 15, 5);

        doc.setFontSize(8);
        doc.text(
          250,
          6,
          `Generated Date and Time  -  ${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
          'center',
        );

        const conditions = [
          { key: 'customerquery', label: 'Customer' },
          { key: 'customerTypequery', label: 'Customer Type' },
        ];
        // Function to get text based on filter data
        const getText = (key, label, value) => {
          return value ? `${label} - ${value}` : '';
        };
        // Iterate over conditions and build the text
        let height = conditions.reduce((acc, condition) => {
          const value = this.filterDatas[condition.key];
          const text = getText(condition.key, condition.label, value);
          if (text) {
            doc.text(text, 15, acc);
            return acc + 5; // Increment
          }
          return acc;
        }, 12); // Initial
        // Add Date Range if both start and end are available
        if (this.filterDatas.start && this.filterDatas.end) {
          const dateRangeText = `Date Range - ${this.filterDatas.start} - ${this.filterDatas.end}`;
          doc.text(dateRangeText, 15, height);
          height += 5; // Increment
        }
        // Set a default height if no conditions matched
        height = height || 20;

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: height,
          },
        );
        const today = new DateTime();
        doc.save(`${moment(today).format('DD-MM-YYYY')}-Customers.pdf`);
      };
      this.generateReport(printPdf);
    },
    //Product Details Export Excel
    exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable13');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format('DD-MM-YYYY')}-customer.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
  },
  computed: {
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
    ...mapState(['filterDatas']),
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },

  watch: {
    filter(value) {
      this.$store.commit('UPDATE_PDF_DATAS', null);
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
    },
  },
};
</script>
<style>
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  border-radius: 6px;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 31px;
}
</style>
